import { buildApiCall } from '@he-novation/config/apis/api-fetch';
import { API_LOCALE_LANGUAGES_AND_COUNTRY_CODES } from '@he-novation/config/apis/locale-api';
import { LanguageAndCountryCode } from '@he-novation/config/types/locale.types';

export const asyncLanguagesAndCountryCodesFetch = (
    locale: string
): Promise<LanguageAndCountryCode[]> =>
    buildApiCall(API_LOCALE_LANGUAGES_AND_COUNTRY_CODES.LIST)({ params: { locale } });
